export default {
    "dynamicFormsDuplicte_title": "Copiar formulario: ",
    "dynamicFormsDuplicte_duplicate": "Copiar",
    "dynamicFormsDuplicte_warning": "¿Está seguro de que desea copiar el formulario? Esta acción no copiará las respuestas.",
}